import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { MascotLoader } from "@/components/MascotLoader";

interface RequireAuthProps {
  children: ReactNode;
}

/**
 * Wraps protected routes. If the user is not authenticated, redirects to
 * /auth?redirect=<current-path> so they return to the intended page after sign-in.
 * Uses the same useAuth hook as the rest of the app to stay consistent.
 */
export function RequireAuth({ children }: RequireAuthProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <MascotLoader />
      </div>
    );
  }

  if (!user) {
    const intended = `${location.pathname}${location.search}`;
    const redirectParam = encodeURIComponent(intended);
    return <Navigate to={`/auth?redirect=${redirectParam}`} replace />;
  }

  return <>{children}</>;
}
